<template>
  <i v-if="name" :data-lucide="name" :style="style"></i>
</template>

<script>
export default {
  name: "UiIcon",
  props: {
    name: {
      type: String,
      required: true,
      default: "circle",
    },
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: "",
    },
  },
  computed: {
    style() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        opacity: `0.8`,
        color: this.color,
        strokeWidth: `1.25px`,
      };
    },
  },
  watch: {
    name(newName) {
      this.refreshIcons(newName);
    },
  },
  methods: {
    refreshIcons(newName) {
      this.$nextTick(() => {
        lucide.createIcons();
        console.log("Icon refreshed:", newName);
      });
    },
  },
  created() {
    lucide.createIcons();
  },
  mounted() {
    lucide.createIcons();
  },
};
</script>
